import primarytrip from "../components/views/primaryTrip/primarytrip.vue";
import addPrimaryTrip from "../components/views/primaryTrip/addPrimaryTrip.vue";
import viewPrimaryTrip from "../components/views/primaryTrip/viewPrimaryTrip.vue";
import houseDetails from "../components/views/primaryTrip/houseDetails.vue";

const routes = [
  {
    path: "/primarytrip",
    component: primarytrip,
    name: "Primarytrip",
    meta: {
      description: "List of Primary Trip",
      title: "Primary Trip",
      requiresAuth: true,
    },
  },

  {
    path: "primarytrip/addPrimaryTrip/:_id",
    component: addPrimaryTrip,
    name: "addPrimaryTrip",
    meta: {
      // description: 'Add Primary Trip',
      title: "Add / Update Primary Trip",
      requiresAuth: true,
    },
  },

  {
    path: "primarytrip/viewPrimaryTrip/:_id",
    component: viewPrimaryTrip,
    name: "viewPrimaryTrip",
    meta: {
      description: "",
      title: "Primary Trip Details",
      requiresAuth: true,
    },
  },

  {
    path: "primarytrip/viewPrimaryTrip/:tripId/:_id",
    component: houseDetails,
    name: "houseDetails", 
    meta: {
      description: "",
      title: "House List",
      requiresAuth: true,
    },
  },
];

export default routes;



// WEBPACK FOOTER //
// ./src/routes/primaryTrip.route.js